import {useGetStatesByFlowQuery} from '../queries/useGetStatesByFlowQuery/useGetStatesByFlowQuery';
import {StatesQueryParams} from './types';

export const useGetStatesQuery = ({
	flowType,
	cdPlanoANSOdonto,
	nuRegistroPlano,
}: StatesQueryParams) =>
	useGetStatesByFlowQuery({flowType, cdPlanoANSOdonto, nuRegistroPlano}, !!flowType);
